<template>
  <section>
    <NavText text="Others" class="pl-2" />

    <div v-for="(navItem, index) in navLink" :key="index" class="">
      <!-- no dropdown -->

      <section v-if="othersidenav(navItem)">
        <NoDropdownNav :navItem="navItem" :getNavIcon="getNavIcon" />
      </section>

      <!-- dropdown -->
      <section v-if="othersidenav(navItem)">
        <DropdownNav :navItem="navItem" :getNavIcon="getNavIcon" />
      </section>

      <!--  -->
    </div>
  </section>
</template>

<script>
//components
import NavText from "../Text/NavText.vue";
import DropdownNav from "@/components/UI/AutomatedSidebar/DropdownNav.vue";
import NoDropdownNav from "@/components/UI/AutomatedSidebar/NoDropdownNav.vue";

export default {
  name: "othersidenavs",
  props: ["navLink", "getNavIcon", "modules"],
  components: {
    NavText,
    DropdownNav,
    NoDropdownNav,
  },
  methods: {
    //utilities
    othersidenav(navItems) {
      const nav = navItems?.name?.toLowerCase();
      if (
        (nav === "teams" && this.modules?.includes("teams")) ||
        (nav === "support" && this.modules?.includes("support")) ||
        (nav === "feedback" && this.modules?.includes("feedback")) ||
        (nav === "settings & control" &&
          this.modules?.includes("settings & control"))
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style></style>
